<template>
    <div class="p-4">
        <h5 class="mb-3">Reçete</h5>
        <table class="table">
            <thead>
                <tr>
                    <th class="col-3">İlaç</th>
                    <th>Miktar (Doz)</th>
                    <th>Periyod (Saat)</th>
                    <th>Süre (Gün)</th>
                    <th class="col-3">Açıklama</th>
                    <th>İşlem</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, index) in prescriptionData" :key="index">
                    <td>
                        <select v-model="row.medicine" class="form-select form-select-sm">
                            <option v-for="medicine in medicines" :key="medicine.medicine_id"
                                :value="medicine.medicine_id">
                                {{ String(medicine.quantity).padStart(4, '0') }} Ad. {{
                                    medicine.medicine_name
                                }}
                            </option>
                        </select>
                    </td>
                    <td><input type="number" class="form-control" v-model="row.quantity" /></td>
                    <td><input type="number" class="form-control" v-model="row.period" /></td>
                    <td><input type="number" class="form-control" v-model="row.duration" /></td>
                    <td><input type="text" class="form-control" v-model="row.description" /></td>
                    <td>
                        <button class="btn btn-danger btn-lg" @click="removeRow(index)">
                            Sil
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <button class="btn btn-primary me-2 btn-sm" @click="addRow">Satır Ekle</button>
    </div>
</template>

<script>
export default {
    name: "AddPrescription",
    props: {
        medicationId: {
            type: Number,
            required: true
        },
        warehouseId: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            prescriptionData: [
                { medicine: "", quantity: 0, period: "", duration: 0, description: "" }
            ],
            medicines: [],
        };
    },
    mounted() {
        this.fetchMedicines();
    },
    methods: {
        async fetchMedicines() {
            try {
                const response = await this.$axios.get(`warehouse-stock/`);
                this.medicines = response.data;
                console.log('reçete medicines çalıştı', this.medicines);
            } catch (error) {
                console.error(error);
            }
            console.log('medicines çalıştı', this.medicines);
        },
        addRow() {
            this.prescriptionData.push({ medicine: "", quantity: 0, period: "" });
        },
        removeRow(index) {
            this.prescriptionData.splice(index, 1);
        },
    }
};
</script>